import React from 'react';
import { Label, LargeInput, ErrorMessage } from 'styles/Styles.styled';
import { useField } from 'formik';

const LargeTextInput = ({ label, ...props }: any) => {
  const [field, meta] = useField(props);
  return (
    <>
      {label && <Label htmlFor={props.id || props.name}>{label}</Label>}
      <LargeInput {...field} {...props} />
      {meta.touched && meta.error && !props.supressErrors ? <ErrorMessage>{meta.error}</ErrorMessage> : null}
    </>
  );
};

export default LargeTextInput;
